'use client';

import {AppBar, Box, Container, IconButton, styled, Toolbar} from '@mui/material';
import {MuiNextLink} from '@/components/MuiNextLink';

type StyledHeaderAppBarProps = {
    isScrolled: boolean;
    isHeaderVisible: boolean;
};

export const StyledHeaderAppBar = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'isScrolled' && prop !== 'isHeaderVisible',
})<StyledHeaderAppBarProps>(({ theme, isScrolled, isHeaderVisible }) => ({
  backgroundColor: isScrolled ? theme.palette.background.lightGrey : 'transparent',
  backgroundImage: 'none',
  boxShadow: 'none',
  color: theme.palette.text.dark,
  opacity: isHeaderVisible ? 1 : 0,
  visibility: isHeaderVisible ? 'visible' : 'hidden',
  pointerEvents: isHeaderVisible ? 'auto' : 'none',
  transition: theme.transitions.create(['background-color', 'opacity', 'visibility'], {
    duration: theme.transitions.duration.complex,
  }),
  'body:has([data-hero-media]) &': {
    backgroundColor: isScrolled ? theme.palette.background.dark : 'transparent',
    color: theme.palette.text.primary,
  },
}));

export const StyledHeaderContainer = styled(Container)(({ theme }) => ({
  padding: theme.spacing(1),
}));

export const StyledHeaderToolbar = styled(Toolbar)(() => ({
  justifyContent: 'space-between',
  gap: 16
}));

export const StyledLogoLink = styled(MuiNextLink)(({ theme }) => ({
  fontWeight: theme.typography.logoLink.fontWeight,
  fontSize: theme.typography.logoLink.fontSize,
  textDecoration: 'none',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 16,
  lineHeight: 1,
  marginRight: theme.spacing(4),
}));

export const StyledDesktopNav = styled(Box)(({ theme }) => ({
  display: 'none',
  gap: theme.spacing(4),
  alignItems: 'center',
  margin: '0 16px', // Adjust for IconButton padding
  marginRight: 'auto',
  
  [theme.breakpoints.up('headerAlignment')]: {
    display: 'flex',
  },
}));

export const StyledMobileMenuButton = styled(IconButton)(({ theme }) => ({
  display: 'flex',

  [theme.breakpoints.up('headerAlignment')]: {
    display: 'none',
  },
}));